import { render } from "./leftNumberRightImageSection.vue?vue&type=template&id=5743bb90&scoped=true"
import script from "./leftNumberRightImageSection.vue?vue&type=script&lang=js"
export * from "./leftNumberRightImageSection.vue?vue&type=script&lang=js"

import "./leftNumberRightImageSection.vue?vue&type=style&index=0&id=5743bb90&scoped=true&lang=css"

import exportComponent from "C:\\onetap\\onetap\\frontend\\onetapuser\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5743bb90"]])

export default __exports__